<template>
	<div>
		<base-modal :show="!!error" title="An error occurred" @close="handleError">
			<p>{{ error }}</p>
		</base-modal>
		<base-loader :show="isLoading"> </base-loader>
		<div v-if="user" class="row mt-5">
			<div v-if="user.userType === 'League Manager'" class="col-md-4"></div>
			<div class="col-md-4 mb-3">
				<div class="card text-info" style="background-color: #263238">
					<div class="card-header h3">My Info</div>
					<div class="card-body">
						<form @submit.prevent="submitEditedUserInfoForm">
							<div class="row g-2">
								<div class="col-md">
									<div class="form-floating">
										<input
											type="text"
											id="floatingFName"
											class="form-control"
											v-model.trim="user.firstName"
										/>
										<label for="floatingFName">First Name</label>
									</div>
								</div>
								<div class="col-md">
									<div class="form-floating">
										<input
											type="text"
											class="form-control"
											id="floatingLName"
											v-model.trim="user.lastName"
										/>
										<label for="floatingLName">Last Name</label>
									</div>
								</div>
								<h5 class="mt-4 text-start">Your Positions</h5>
								<div class="text-start">
									<input v-model="positions" value="P" type="checkbox" class="btn-check" id="P" />
									<label class="btn btn-outline-info me-1 mt-1" for="P">P</label>
									<input v-model="positions" value="C" type="checkbox" class="btn-check" id="C" />
									<label class="btn btn-outline-info me-1 mt-1" for="C">C</label>
									<input v-model="positions" value="1B" type="checkbox" class="btn-check" id="1B" />
									<label class="btn btn-outline-info me-1 mt-1" for="1B">1B</label>
									<input v-model="positions" value="2B" type="checkbox" class="btn-check" id="2B" />
									<label class="btn btn-outline-info me-1 mt-1" for="2B">2B</label>
									<input v-model="positions" value="3B" type="checkbox" class="btn-check" id="3B" />
									<label class="btn btn-outline-info me-1 mt-1" for="3B">3B</label>
									<input v-model="positions" value="SS" type="checkbox" class="btn-check" id="SS" />
									<label class="btn btn-outline-info me-1 mt-1" for="SS">SS</label>
									<input v-model="positions" value="LF" type="checkbox" class="btn-check" id="LF" />
									<label class="btn btn-outline-info me-1 mt-1" for="LF">LF</label>
									<input v-model="positions" value="CF" type="checkbox" class="btn-check" id="CF" />
									<label class="btn btn-outline-info me-1 mt-1" for="CF">CF</label>
									<input v-model="positions" value="RF" type="checkbox" class="btn-check" id="RF" />
									<label class="btn btn-outline-info me-1 mt-1" for="RF">RF</label>
								</div>
								<div class="text-start mb-4"></div>
							</div>
							<div class="col-md mb-4">
								<div class="form-floating">
									<input
										maxlength="2"
										type="tel"
										class="form-control"
										id="floatingLName"
										v-model.trim="user.number"
									/>
									<label for="floatingLName">Your Number</label>
								</div>
							</div>
							<div class="text-start mt-2">
								<span class="text-decoration-underline">Email</span>: {{ user.email }}
							</div>
							<div class="text-start mt-2">
								<span class="text-decoration-underline">League</span>: {{ user.league }}
							</div>
							<div v-if="user.division === ''"></div>
							<div v-else class="text-start mt-2">
								<span class="text-decoration-underline">Division</span>: {{ user.division }}
							</div>
							<div v-if="user.team === ''">df</div>
							<div v-else class="text-start mt-2">
								<span class="text-decoration-underline">Team</span>: {{ user.team }}
							</div>
							<button class="btn btn-info mt-4">Save</button>
						</form>
					</div>
				</div>
			</div>
			<div v-if="user.userType !== 'League Manager'" class="col-md-8 mb-3">
				<div class="card text-info" style="background-color: #263238">
					<div class="card-header h3">My Stats</div>
					<div class="card-body">
						<h5 class="text-start">Batting</h5>
						<div class="row">
							<div class="col-md-4 mb-4 mb-md-0">
								<div class="card bg-info" style="color: #263238">
									<div class="card-body">
										<h5 class="mb-1">Avg</h5>
										<h2 class="mb-0">{{ getStats.BA }}</h2>
									</div>
								</div>
							</div>
							<div class="col-md-4 mb-4 mb-md-4">
								<div class="card bg-info" style="color: #263238">
									<div class="card-body">
										<h5 class="mb-1">On Base%</h5>
										<h2 class="mb-0">{{ getStats.OBP }}</h2>
									</div>
								</div>
							</div>
							<div class="col-md-4 mb-4 mb-md-4">
								<div class="card bg-info" style="color: #263238">
									<div class="card-body">
										<h5 class="mb-1">Slugging%</h5>
										<h2 class="mb-0">{{ getStats.SLG }}</h2>
									</div>
								</div>
							</div>
						</div>
						<div class="row m-1 overflow-auto">
							<table
								class="table table-responsive text-info text-start"
								style="background-color: #263238"
							>
								<thead>
									<tr>
										<th scope="col">Season</th>
										<th scope="col">AB</th>
										<th scope="col">H</th>
										<th scope="col">2B</th>
										<th scope="col">3B</th>
										<th scope="col">HR</th>
										<th scope="col">BB</th>
										<th scope="col">SO</th>
										<th scope="col">AVG</th>
										<th scope="col">OBP</th>
										<th scope="col">SLG</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th scope="row">1</th>
										<td>{{ getStats.atBats }}</td>
										<td>{{ getStats.singles }}</td>
										<td>{{ getStats.doubles }}</td>
										<td>{{ getStats.triples }}</td>
										<td>{{ getStats.homeruns }}</td>
										<td>{{ getStats.walks }}</td>
										<td>{{ getStats.so }}</td>
										<td>{{ getStats.BA }}</td>
										<td>{{ getStats.OBP }}</td>
										<td>{{ getStats.SLG }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-if="positions.includes('P') && getStats.ip">
							<div class="row mt-4">
								<h5 class="text-start">Pitching</h5>
								<div class="col-md-3 mb-4 mb-md-0">
									<div class="card bg-info" style="color: #263238">
										<div class="card-body">
											<h5 class="mb-1">IP</h5>
											<h2 class="mb-0">{{ getStats.ip }}</h2>
										</div>
									</div>
								</div>
								<div class="col-md-3 mb-4 mb-md-0">
									<div class="card bg-info" style="color: #263238">
										<div class="card-body">
											<h5 class="mb-1">Hits</h5>
											<h2 class="mb-0">{{ getStats.hits }}</h2>
										</div>
									</div>
								</div>
								<div class="col-md-3 mb-4 mb-md-0">
									<div class="card bg-info" style="color: #263238">
										<div class="card-body">
											<h5 class="mb-1">Runs</h5>
											<h2 class="mb-0">{{ getStats.runs }}</h2>
										</div>
									</div>
								</div>
								<div class="col-md-3 mb-4 mb-md-0">
									<div class="card bg-info" style="color: #263238">
										<div class="card-body">
											<h5 class="mb-1">ER</h5>
											<h2 class="mb-0">{{ getStats.er }}</h2>
										</div>
									</div>
								</div>
							</div>
							<div class="row mt-4">
								<div class="col-md-3 mb-4 mb-md-0">
									<div class="card bg-info" style="color: #263238">
										<div class="card-body">
											<h5 class="mb-1">BB</h5>
											<h2 class="mb-0">{{ getStats.bb }}</h2>
										</div>
									</div>
								</div>
								<div class="col-md-3 mb-4 mb-md-0">
									<div class="card bg-info" style="color: #263238">
										<div class="card-body">
											<h5 class="mb-1">Ks</h5>
											<h2 class="mb-0">{{ getStats.k }}</h2>
										</div>
									</div>
								</div>
								<div class="col-md-3 mb-4 mb-md-0">
									<div class="card bg-info" style="color: #263238">
										<div class="card-body">
											<h5 class="mb-1">ERA</h5>
											<h2 v-show="getStats.era > 0" class="mb-0">{{ getStats.era }}</h2>
										</div>
									</div>
								</div>
								<div class="col-md-3">
									<div class="card bg-info" style="color: #263238">
										<div class="card-body">
											<h5 class="mb-1">Whip</h5>
											<h2 v-show="getStats.whip > 0" class="mb-0">{{ getStats.whip }}</h2>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="col-md-3">
			<div class="card text-info" style="background-color: #263238">
				<div class="card-header h3">Team feed</div>
				<div class="card-body">show team dugout feed</div>
			</div>
		</div> -->
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			user: null,
			error: null,
			user: {
				firstName: '',
				lastName: '',
				number: '',
			},
			positions: [],
			isLoading: false,
		};
	},
	created() {
		this.loadUsers();
	},
	computed: {
		userLeagueId() {
			return this.$store.getters.userLeagueId;
		},
		userType() {
			return this.$store.getters.userType;
		},
		userTeam() {
			return this.$store.getters.userTeam;
		},
		userEmail() {
			return this.$store.getters.userEmail;
		},
		userLeague() {
			return this.$store.userLeague;
		},
		allDivisions() {
			return this.$store.getters['leagues/allDivisions'];
		},
		getStats() {
			return this.$store.getters['stats/getStats'];
		},
		getUserId() {
			return this.$store.getters.userId;
		},
	},
	methods: {
		async submitEditedUserInfoForm() {
			const payload = {
				firstName: this.user.firstName,
				lastName: this.user.lastName,
				positions: this.positions,
				number: this.user.number
			};
			try {
				this.isLoading = true;
				await this.$store.dispatch('editedUserInfo', payload);
			} catch (err) {
				this.error = err.message || 'Set user info failed... Try again.';
			}
			this.$router.go();
			this.loadUsers();
		},
		getUser() {
			const userId = this.$store.getters.userId;
			const users = this.$store.getters['allUsers'];
			const user = users.filter((user) => user.id === userId);
			if (user[0].positions) {
				this.positions = user[0].positions;
			}
			if (user[0].stats) {
				this.loadUserStats();
			}
			this.user = user[0];
		},
		async loadUsers() {
			try {
				await this.$store.dispatch('fetchUsers');
				this.getUser();
			} catch (error) {
				this.error = error.message || 'Something went wrong!';
			}
		},
		async loadUserStats() {
			const payload = {
				userId: this.getUserId,
			};
			try {
				await this.$store.dispatch('stats/fetchUserStats', payload);
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
		},
		handleError() {
			this.error = null;
		},
	},
};
</script>

<style scoped>
.md-form label.active {
	color: #39c0ed !important;
}
.md-form input {
	color: #39c0ed !important;
}

.md-form input:focus {
	border-bottom: 0.5px solid #39c0ed !important;
	box-shadow: 0 1px 0 0 #39c0ed !important;
	color: #39c0ed !important;
}

.md-form input readonly {
	border-bottom: 0.5px solid #39c0ed !important;
	box-shadow: 0 1px 0 0 #39c0ed !important;
	color: #39c0ed !important;
}
</style>
